import { lazy } from 'react';

const LazyConfigFlowWrapper = lazy(() => import('./config-flow-wrapper'));

export default LazyConfigFlowWrapper;
